import { MainPageProps } from 'models/MainPageProps';
import { getCategoriesFromApi } from './getCategoriesFromApi';
import { Environment } from 'models/Environment';
import { TargetMarket } from 'models/TargetMarket';

export const getMainPageCategories = async (
  environment: Environment,
  targetMarket: TargetMarket
): Promise<MainPageProps> => {
  const { categories } = await getCategoriesFromApi({
    environment,
    targetMarket
  });
  return {
    categoryList: categories
  };
};
